import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X, Cookie } from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { getCookieConsent, acceptAllCookies, rejectAllCookies, clearCookieConsent } from "@/utils/cookieConsent";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Ne plus afficher automatiquement, uniquement sur demande
  useEffect(() => {
    const handleConsentRequest = () => {
      const consent = getCookieConsent();
      
      if (!consent) {
        setIsVisible(true);
      }
    };
    
    window.addEventListener('requestCookieConsent', handleConsentRequest);
    
    return () => {
      window.removeEventListener('requestCookieConsent', handleConsentRequest);
    };
  }, []);

  useEffect(() => {
    // Écouter l'événement de suppression du consentement
    const handleConsentCleared = () => {
      setIsVisible(true);
    };
    
    window.addEventListener('cookieConsentCleared', handleConsentCleared);
    
    return () => {
      window.removeEventListener('cookieConsentCleared', handleConsentCleared);
    };
  }, []);

  const handleAccept = () => {
    acceptAllCookies();
    setIsVisible(false);
  };

  const handleReject = () => {
    rejectAllCookies();
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 z-[9999] max-w-sm animate-in slide-in-from-bottom-5 duration-300">
      <Card className="shadow-xl border-bbz-beige bg-white">
        <CardHeader className="pb-3">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-2">
              <Cookie className="w-5 h-5 text-bbz-accent" />
              <CardTitle className="text-lg">Cookies</CardTitle>
            </div>
            <Button
              variant="ghost"
              size="icon"
              className="h-6 w-6 -mt-1 -mr-2"
              onClick={handleReject}
              aria-label="Fermer"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <CardDescription className="text-sm leading-relaxed">
            J'utilise des cookies pour améliorer votre expérience et analyser le trafic de mon site.
          </CardDescription>
          
          <Link 
            to="/politique-confidentialite" 
            className="text-sm text-bbz-accent hover:underline inline-block"
          >
            En savoir plus
          </Link>
          
          <div className="flex flex-col gap-2 pt-2">
            <Button
              size="sm"
              onClick={handleAccept}
              className="w-full shadow-md"
            >
              Tout accepter
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleReject}
              className="w-full text-xs"
            >
              Tout refuser
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CookieConsent;
